export const messages_pt = {
    nameEmpty: "O nome não pode estar vazio.",
    emailEmpty: "O endereço de e-mail não pode estar vazio.",
    emailNotValid: "O endereço de e-mail não é válido, por favor, digite um endereço de e-mail apropriado.",
    locationEmpty: "O local não pode estar vazio.",
    interests: "Escolha 3 categorias.",
    profileSaved: "Detalhes do perfil salvos.",
    profilePic: "Imagem de perfil salva.",
    addToFavorites:"Adicionado com sucesso aos seus favorito.",
    removeFromFavorites:"removido com sucesso dos favoritos"
};


// WEBPACK FOOTER //
// ./src/constants/messages_pt.js